import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      infoCounters: {},
    },
    mutations: {
      SET_INFOCOUNTERS(state, { data, locale }) {
        state.infoCounters = {
          ...state.infoCounters,
          [locale]: {
            data,
            __updatedAt: Date.now(),
          }
        }
      }
    },
    actions: {
      FETCH_INFOCOUNTERS({ state, commit }, { locale }) {
        if (state.infoCounters[locale] 
          && state.infoCounters[locale].data
          && Date.now() - state.infoCounters[locale].__updatedAt < cachetime
        ) {
          return ;
        }

        return axios.get('/api/info-counters')
          .then((res) => {
            const data = res.data || {};
            commit('SET_INFOCOUNTERS', { data, locale});
          }).catch(err => console.log(err));
      }
    },
    getters: {
      getInfoCounters: (state) => (locale) => {
        return state.infoCounters[locale] ? state.infoCounters[locale].data || {} : {};
      }
    }
  }
};